import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealerDocumentationsQueryKeys } from "modules/DealerDocumentations/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteDocumentationMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async id => (await ApiInstance.post("/documentations/delete", { id }, ENV.dealerBaseURL)).data,
    onSuccess: id => {
      const dealerDocumentations = typedQueryClient.getQueryData(DealerDocumentationsQueryKeys.list);
      if (!dealerDocumentations) return;

      const docIdx = dealerDocumentations.findIndex(doc => doc.id === id);
      if (docIdx === -1) return;

      typedQueryClient.setQueryData(DealerDocumentationsQueryKeys.list, dealerDocumentations.toSpliced(docIdx, 1));
    }
  });
